<template>
  <a-modal
    class="importmodal"
    :destroyOnClose='true'
    :footer="null"
    :visible="uploadModal"
    title="导入"
    @cancel="uploadcancel"
  >
    <div class="upload">
      <p>
        <a-icon type="exclamation-circle" />上传前请先下载模板，按照模板要求将内容录入到模板中</p>
      <img
        src="../../assets/mine/load_exer.png"
        alt=""
      >
      <p>支持格式：xls、xlsx</p>
      <download
        :name="'下载模板'"
        :api="templateApiurl"
        :fileName="fileName"
        :isPrimary="false"
      ></download>
      <br>
      <a-upload
        :fileList="fileList"
        :remove="handleRemove"
        :beforeUpload="beforeUpload"
        accept='.xls,.xlsx'
      >
        <a-button style='margin-top:20px;'>
          <a-icon type="upload" /> 选择文件
        </a-button>
      </a-upload>
      <a-button
        type="primary"
        @click="handleUpload"
        :disabled="fileList.length === 0"
        style="margin-top: 16px"
      >
      开始上传

        <!-- {{uploading ? '上传中' : '开始上传' }} -->
      </a-button>
    </div>
  </a-modal>
</template>
<script>
// import axios from 'axios'
import download from "@/components/common/download";
// import {getloadTemplateApi} from "@/request/api"
export default {
  name: "downloadAndUpload",
  components: { download },
  props: {
    uploadModal: Boolean,
    templateApiurl: String,
    fileName: String,
    uploading:Boolean
  },
  data() {
    return {
      fileList: [],
    };
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
     // 导入取消
    uploadcancel() {
      this.$emit('uploadcancel')
    },
    handleUpload() {
      const { fileList } = this;
      //const formData = new FormData();

      // fileList.forEach((file) => {
      //     formData.append('file', file);
      // });
      this.$emit("upload", fileList);
      // You can use any AJAX library you like
      // axios.post(window.g.apiUrl+'manage/question/import',formData).then(res=>{
      //     this.fileList = []
      //     this.uploading = false
      //     if(res.data.code==200){
      //         this.$message.success(res.data.message);
      //     }else{
      //         this.$message.error(res.data.message);
      //     }
      //     this.init()
      //     this.openAddItemBox=false
      // }).catch(()=>{
      //     this.uploading = false
      //     this.$message.error('upload failed.');
      // });
    },
  },
};
</script>
<style>
.importmodal .ant-modal-body {
  text-align: center;
  padding: 0px;
  font-size: 14px;
  word-wrap: break-word;
  margin-top: 20px;
}
.importmodal .ant-upload-list-item-info {
  display: flex;
  justify-content: center;
}
.importmodal .ant-btn-primary {
  margin-bottom: 20px;
}
</style>
<style lang="stylus"></style>